import { useContext } from "react";
import { useApiQuery } from "@/api/useApi";
import AuthContext from "src/store/auth-context";

type AdminCheckResponse = { isAdmin: boolean; isRaceAdmin: boolean };

export default function () {
  const authCtx = useContext(AuthContext);
  // Token must be part of the key so the cached admin status resets on logout
  // and never leaks across accounts (a different token = a different cache entry).
  const adminQuery = useApiQuery<AdminCheckResponse>({
    url: "auth/check-if-admin/",
    queryKey: ["isAdmin", authCtx.token],
  });

  return {
    isAdmin: adminQuery.data?.isAdmin ?? false,
    isRaceAdmin: adminQuery.data?.isRaceAdmin ?? false,
    isLoadingAdminCheck: adminQuery.isLoading,
  };
}
